import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Attribute } from '../map-state';
import AttributeTooltip from './AttributeTooltip';

interface AttributesProps {
  data: Record<string, Attribute>;
}
const Attributes = ({ data }: AttributesProps) => {
  const attributes = [] as ReactNode[];

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const showEmpty = queryString.get('showEmpty');

  if (!data) return null;
  Object.entries(data).forEach(
    ([name, attribute]) =>
      name &&
      (showEmpty || attribute.value) &&
      attributes.push(
        <AttributeTooltip
          key={name}
          name={attribute.displayName.toString()}
          value={attribute.value.toString()}
        />
      )
  );

  return <>{attributes.length > 0 ? attributes : null}</>;
};

export default Attributes;
